import { render, staticRenderFns } from "./pub.vue?vue&type=template&id=923cdd74&lang=pug&"
import script from "./pub.vue?vue&type=script&lang=js&"
export * from "./pub.vue?vue&type=script&lang=js&"
import style0 from "./pub.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serg/my/projects/pub.settv.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('923cdd74')) {
      api.createRecord('923cdd74', component.options)
    } else {
      api.reload('923cdd74', component.options)
    }
    module.hot.accept("./pub.vue?vue&type=template&id=923cdd74&lang=pug&", function () {
      api.rerender('923cdd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/pub.vue"
export default component.exports